export const log = (msg, color, {
  debug
}) => {
  if (debug) {
    console.log(`%c${msg}`, `color:${color};font-weight:bold;`);
  }
};
export const isFunction = val => typeof val === 'function';